import React from "react";
import clsx from 'clsx'; 
import Required from "../../utils/Required";
import { err, clsErr } from "../validation";

export default function BookingLimits({ value = {}, onChange, errors = {} }) {
  const upd = (p)=>onChange({ ...value, ...p });
  return (
    <div className="grid grid-cols-2 gap-4 text-sm">
      <label>
        Max Bookings per client&nbsp;/&nbsp;day <Required />
        <input 
        type="number"
        min={0} 
        className={clsx(
          'mt-1 w-full rounded border-gray-300',
        clsErr(errors,'booking_limits.max_per_client_per_day')
        )}
        value={value.max_per_client_per_day||0}
        onChange={(e)=>upd({max_per_client_per_day:Number(e.target.value)})}/>
      </label>
      {err(errors, "booking_limits.max_per_client_per_day") && (
        <p className="text-xs text-red-500 mt-1">
          {err(errors, "booking_limits.max_per_client_per_day")}
        </p>
      )}
      {value.recurring_soft_limit && (
        <p className="col-span-2 text-xs text-gray-500">
          Recurring bookings ignore hard limits but warn the client.
        </p>
      )}
    </div>
  );
}
